module.exports = __webpack_public_path__ + "img/photo-wide-4.ef682002.jpg";